import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Button, Col, FormSelect, Row } from 'shards-react'
import { graduatesOrientationActions, setFormData } from '../../../../redux/reducers/GraduatesOrientation/graduatesOrientationReducer';
import styles from '../styles.module.css'
import { organizationList } from '../../../../redux/reducers/organization-list-reducer'
import { getSchoolYearsList } from '../../../../utils/smallHelpers';
import { ORG_TYPES } from '../../../../constants/const';


const year = new Date().getFullYear();
const yearsList = getSchoolYearsList(year - 6, year, 'reverse');
const formEdu = [{
  id: 1,
  label: 'Все',
  value: '',
},
{
  id: 2,
  label: 'Очно',
  value: 'Очно',
},
{
  id: 3,
  label: 'Онлайн',
  value: 'Онлайн',
}
]

const { graduatesOrientationRequestStart } = graduatesOrientationActions

const Form = ({ form }) => {
  
  const dispatch = useDispatch()

  const orgList = useSelector(state => state.reports.orgList.data)
  const auth = useSelector(state => state.auth.data)

  useEffect(() => {
    if (orgList !== undefined && orgList.length === 0) {
      dispatch(organizationList.organizationListRequestStart(auth))
    }
  }, [])

  const handleChange = (e) => {
    const { name, value } = e.target
    const addschool = (name === 'idOrg' && value !== '0') ? "0" : form.addschool
    dispatch(setFormData({ ...form, addschool, [name]: value }))
  }

  const onSubmit = () => {
    dispatch(graduatesOrientationRequestStart())
  }

  return (
    <Row className={styles.formRow}>
        
        <Col md={2}>
          <label htmlFor="year">Выберите год</label>
          <FormSelect
              id='year'
              name='year'
              size="sm"
              value={form.year}
              onChange={handleChange}
          >
              {yearsList.map(year => <option key={year} value={year} selected={year === form.year}>{year}</option>)}
          </FormSelect>
        </Col>

        <Col md={2}>
          <label htmlFor="form">Выберите форму проведения</label>
          <FormSelect
              id='form'
              name='form'
              size="sm"
              value={form.form}
              onChange={handleChange}
          >
              {formEdu.map(edu => <option key={edu.id} value={edu.value} selected={edu.value === form.report_profotbor}>{edu.label}</option>)}
          </FormSelect>
        </Col>

        <Col md={5}>
          {/* <FormGroup className={'mr-3'}> */}
            <label htmlFor='_idOrg'>Выберите организацию</label>
            <FormSelect
              name='idOrg'
              id='_idOrg'
              size='sm'
              className='d-block'
              value={form.idOrg}
              onChange={handleChange}
              // style={{ width: 730 }}
            >
              <option value={0}>Все организации</option>
              {!!orgList && orgList.map(item => (
                <option key={item.idOrganization} value={item.idOrganization}>
                  {item.orgName}
                </option>
              ))}
            </FormSelect>
          {/* </FormGroup> */}
        </Col>

        {form.idOrg === '0' && (
          <Col md={2}>
            {/* <FormGroup> */}
              <label htmlFor='addschool'>Тип ОО</label>
              <FormSelect
                name='addschool'
                id='addschool'
                size='sm'
                className='md-block'
                onChange={handleChange}
                value={form.addschool}
              >
                {ORG_TYPES.map(({name, value}) => <option key={value} value={value}>{name}</option>)}
              </FormSelect>
            {/* </FormGroup> */}
          </Col>
        )}

        <Button onClick={onSubmit}>Создать отчет</Button>

    </Row>
  )
}

export default Form